(function () {
	const _nav = document.getElementById('primary-nav');
	const _toggleButton = document.getElementById('primary-nav-toggle-button');
	
	_toggleButton.addEventListener('click', () => {
		util.toggleClass(_toggleButton, 'is-active');
		util.toggleClass(_nav, 'is-visible');
	});
	
	_nav.addEventListener('click', () => {
		util.removeClass(_toggleButton, 'is-active');
		util.removeClass(_nav, 'is-visible');
	});
}());

(function () {
	const _contactForm = document.getElementById('contact-form');
	
	if (!_contactForm) {
		return;
	}
	
	new FormValidator(_contactForm, {
		errorMode: 'alert',
		resetAfterSubmit: true,
		
		onsuccess: (response) => {
			alert(response);
		},
	});
}());